module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAAXNSR0IArs4c6QAAAHRJREFUKFNjTPI2v8/IyKDw/z/Dg3lbTyome5vFMzAyLmDAAkBqGJN9zP/D5OZuOcmY5GNWz8jA2IBNA0iMkWQbcJmE0waQm/8zMigw/md4MHfrqYUJHgYKTCxs8dg0gNSQ7geSPU2yk0j2NMnBSrIfSLUBAC4UWzOUvKXSAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/list2.png
// module id = FMot
// module chunks = 1